"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _default = function _default(theme) {
  return {
    root: {
      display: 'inherit'
    },
    truncated: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    small: (0, _extends2.default)({
      fontStyle: 'normal',
      lineHeight: 'normal'
    }, theme.typography.smallText),
    medium: (0, _extends2.default)({
      fontStyle: 'normal',
      lineHeight: 1.54
    }, theme.typography.defaultText),
    large: (0, _extends2.default)({
      fontStyle: 'normal',
      lineHeight: 1.25
    }, theme.typography.largeText),
    big: (0, _extends2.default)({
      fontStyle: 'normal',
      lineHeight: 'normal'
    }, theme.typography.bigText),
    bold: {
      fontWeight: 500,
      color: theme.colors.text.black
    },
    normal: {
      fontWeight: 'normal',
      color: theme.colors.greySoft
    },
    light: {
      fontWeight: 'normal',
      color: theme.colors.disabledGrey
    },
    isLoading: {
      display: 'flex',
      alignItems: 'center'
    },
    Loader: {
      marginTop: -2,
      marginRight: 10
    }
  };
};

exports.default = _default;